<template>

</template>

<script>
import TextInput from '../Donation/TextInput';
export default {
      name: "FundraiserStepOne",
      components: {
        TextInput,
      },
      data: () => ({
        csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        step: 1,
        email: undefined,
        validationErrors: undefined,
      }),
      methods: {
        submitForm(e) {
          if(typeof this.email === 'undefined' || this.email === ''){
            this.validationErrors = true;
            this.validationMessage = "Please enter your email";
          } else {
            console.log(e);
            e.srcElement.submit();
          }


        },
      }
    }
</script>

<style scoped>

</style>
